module.exports = __webpack_public_path__ + "img/logo1.996d987f.png";